import { keycloakInit } from '@/services/api';
import Appbar from '../components/appbar/appbar.vue'
import {useTemplateRef, defineComponent } from "vue";
import { i18n } from '@/app-i18n';
import { CheckIcon } from 'lucide-vue-next'
// import { useToast } from "vue-toastification";
// import { toast } from '../components/toast/toastSub';
import  Toast  from '../components/toast/toast.vue'
// import {VSnackbar} from 'vuetify/components';


export default defineComponent( {
  name: 'MissionOperationView',
  data() {
    return {
     
      steps:[] as any[],
      completedSteps:[{id:1}]
    };
  },
  components: {
      Appbar,
      Toast
  },
  setup(){
    const toast=useTemplateRef<ToastRef>("toast");
    return {toast};
  },
  mounted: async function() {

    this.steps = [
      { id: 1, title: "Step 1", description: "Upload your mission code to the Leanbot.",link:conf.missions.urlIde,completed:false },
      { id: 2, title: "Step 2", description: "Link Leanbot to the gateway to send and receive data.",link:"/gateway",completed:false },
      { id: 3, title: "Step 3", description: "Navigate to the mission page to view the results.",link:"/experience",completed:false },
    ]
    // debugger;
    this.toast.show("xxxxxxxxxxxxxx Please complete the previous step before proceeding to the next step.");
    setTimeout(()=>{
      this.toast.show("kkkkkkkkk.");
      setTimeout(()=>{
        this.toast.show("lllllllllllll.");
      },1000);
    },1000);
  
  },
  
  methods: {
    
    toggleStep (step:any,index:number) {
      const newUrl = new URL(location.href);
      newUrl.pathname = step.link; // Replace the path
      var nu=newUrl.toString();
      // toast.next({toastMessage:"Please complete the previous step before proceeding to the next step.",toastVisible:true});
      if (step.completed){ 
        if (index==2) {
          window.open(nu, step.title);
        }
      } else {
        if (index==0) {
          step.completed=true;
          window.open(step.link,step.title);
        } else {

          if (this.steps[index-1].completed) {
            step.completed=true;
           
            window.open(nu, step.title);
            
          } else {
            this.toast.show("Please complete the previous step before proceeding to the next step.");
            // generate float message promt user completed previous step
            // toast.next({toastMessage:"Please complete the previous step before proceeding to the next step.",toastVisible:true});
            // this.toast.info("Please complete the previous step before proceeding to the next step.");
          }
        }
        
      }
     
    },
   
  }
})
